<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  methods: {
    init() {
      let that = this
      let datetime = this.getDateTime()
      // console.log(this.dateTime)
      localStorage.setItem('dateTime', JSON.stringify(datetime))
      setTimeout(() => {
        that.init()
      }, 1000);  
    },
    getDateTime() {
      var date = new Date() //实例一个时间对象
      this.year = date.getFullYear() //获取完整的年份（4位）
      this.month = date.getMonth() + 1 //获取当前月份，由于月份从0开始计算，要+1
      this.date = date.getDate() //获取当前日（1-31）
      this.day = new Array(
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      )[date.getDay()] //获取星期
      this.hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() //获取当前小时数（0-23）
      this.minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() //获取当前分钟数（0-59）
      this.second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() //获取当前秒数（0-59）

      //当前详细日期时间
      return (
        this.year +
        '年' +
        this.month +
        '月' +
        this.date +
        '日 ' +
        this.day + ' ' +
        this.hour +
        ':' +
        this.minute +
        ':' +
        this.second +
        ' ' 
      )
    },
  },
  created() {
    document.title = '太仓市大学生创业园'
  //   let that = this
  //   let pathArr = ['/', '/roadside', '/shajiabang']
  //   document.onkeydown = function (e) {
  //     //事件对象兼容
  //     let e1 =
  //       e || event || window.event || arguments.callee.caller.arguments[0]
  //     // console.log(e1);
  //     // console.log(that.$router);
  //     let router = that.$router;
  //     let path = router.history.current.fullPath;
  //     let i = 0;
  //     while(path != pathArr[i]) {
  //       i++;
  //     }
  //     // console.log(path)
  //     // 下箭头 40
  //     // 上箭头 38
  //     if (e1 && e1.keyCode == 37) {      //  <--
  //       if(i == 0)
  //       i = 3;
  //       router.push({ path: pathArr[i - 1] })
  //       //  console.log('左箭头')
  //     }else if (e1 && e1.keyCode == 39) {  //  -->
  //       if(i == 2)
  //       i = -1;
  //       router.push({ path: pathArr[i + 1] })
  //       //  console.log('右箭头')
  //     }         
  //   }
    this.init()
  }
}
</script>

<style lang="less">
// html,body{
//   padding: 0 !important;
//   margin: 0 !important;
// }
// #app {
//   width: 100vw;
// }

</style>